import { faProjectDiagram } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function testBus() {
    return (
        <div data-cy="historic-testBus">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.testBus" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faProjectDiagram} style={{ color: 'orange' }} size="lg" />
            </Whisper>
        </div>
    );
}
